import React from 'react';
import './welcome-content.scss';

export default function WelcomeContent(): JSX.Element {
   return (
      <div className="welcome-content">
         <div className="body-large-semibold primary-brand-orange">
            Welcome to the NEW DUIDash™!
         </div>
         <div className="large-type">
            Get Easy Access to Your Clients’ Service and Device Data
         </div>
         <div className="body-large-light">
            DUIDash™ is your one stop for client information for Intoxalock
            Ignition Interlock® and Breathe Easy Insurance®.
         </div>
      </div>
   );
}
